import { render, staticRenderFns } from "./SkinSetLabelDialog.vue?vue&type=template&id=5a16eb87&scoped=true&"
import script from "./SkinSetLabelDialog.vue?vue&type=script&lang=ts&"
export * from "./SkinSetLabelDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a16eb87",
  null
  
)

export default component.exports